import axios from "axios"

import { useState } from "react"
import { useSelector } from "react-redux"
import { useToast } from '@chakra-ui/react'
import sockets from "../../../../socket/socket"
const socket = sockets;



export default function ButtonDeleteTask({ item, index,onClose,update}) {

  const [delLoad, setDelload] = useState(false);

  let getCompanyID = useSelector(compID => compID.checkedSessionReducer);
  const getmyino = useSelector(getmyinfo => getmyinfo);
  const toast = useToast();


  const handleDelet = (card) => {
    console.log(card.creatorTasks);
    if (card.creatorTasks == getmyino.getMayInfoReducer.myinfo._id) {
      setDelload(true)

      axios.post('/taskmeneger/delete/api', {
        companyID: card.companyID,
        cardID: card._id
      })
        .then(function (response) {
         
          socket.emit('getAllTask', { companyIDS: getCompanyID.checkedSession });
          socket.emit('getNotifyEmit');
          socket.emit('message', { room: getCompanyID.checkedSession });
          update()
          onClose()
          setDelload(false)
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      toast({
        position: "top",
        title: 'Вы не можете удалить эту задачу, поскольку не являетесь ее создателем.',
        description: "Вы не можете удалить эту задачу, поскольку не являетесь ее создателем.",
        status: 'error',
        duration: 2000,
        isClosable: true,
      })
    }


  }

  if (delLoad) {
    return <div class="custom-loaderDeletTask"></div>
  } else {
    return <div className="deletTask" onClick={() => handleDelet(item)}>

      <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fillRule="evenodd" clipRule="evenodd" d="M8.5 6V3.5H15V6H8.5ZM7.75 7.5H15.75H20.75C21.1642 7.5 21.5 7.16421 21.5 6.75C21.5 6.33579 21.1642 6 20.75 6H16.5V3.35C16.5 2.60444 15.8956 2 15.15 2H8.35C7.60442 2 7 2.60442 7 3.35V6H2.75C2.33579 6 2 6.33579 2 6.75C2 7.16421 2.33579 7.5 2.75 7.5H7.75ZM5.5 10.75C5.5 10.3358 5.16421 10 4.75 10C4.33579 10 4 10.3358 4 10.75V20.15C4 20.8956 4.60444 21.5 5.35 21.5H18.15C18.8956 21.5 19.5 20.8956 19.5 20.15V10.75C19.5 10.3358 19.1642 10 18.75 10C18.3358 10 18 10.3358 18 10.75V20H5.5V10.75ZM10.5 10.75C10.5 10.3358 10.1642 10 9.75 10C9.33579 10 9 10.3358 9 10.75V16.75C9 17.1642 9.33579 17.5 9.75 17.5C10.1642 17.5 10.5 17.1642 10.5 16.75V10.75ZM13.75 10C14.1642 10 14.5 10.3358 14.5 10.75V16.75C14.5 17.1642 14.1642 17.5 13.75 17.5C13.3358 17.5 13 17.1642 13 16.75V10.75C13 10.3358 13.3358 10 13.75 10Z" fill="#DD5E98" />
        </svg>
        <p>Удалить</p>
      </div>
     
    </div>
  }
}